import { Server, ShoppingCart, CreditCard, ShieldCheck, HardDrive, Code2, Headphones, Cpu, Network, TerminalSquare, Globe2, ArrowUp, Sparkles, Languages, Zap, Wrench, Laptop, Smartphone, Gamepad2, Printer, Shield, Apple, MapPin } from 'lucide-react';

const map = { Server, ShoppingCart, CreditCard, ShieldCheck, HardDrive, Code2, Headphones, Cpu, Network, TerminalSquare, Globe2, ArrowUp, Sparkles, Languages, Zap, Wrench, Laptop, Smartphone, Gamepad2, Printer, Shield, Apple, MapPin };

export const Icon = ({ name, ...props }) => {
  const Cmp = map[name] || Cpu;
  return <Cmp {...props} />;
};
